import {
  AibBlockLine,
  GridItemTrafficLight,
  isAioExternalSingle,
  isGridItemTrafficLight,
  isObjectRecord,
} from "aic";
import { AioExternalSingleWithSource } from "contexts/hierarchy/interface";
import { IEditorV3, isIEditorV3 } from "editor-v3";
import { CommentReadDto } from "../comments/interface";
import { isCommentReadDto } from "../comments/isCommentReadDto";
import { eTlfOutputType } from "../enums";
import { isTlfItemIndexReadDto, TlfItemIndexReadDto } from "./TlfItemIndexReadDto";

export interface TitlesFootnotesReadDto extends TlfItemIndexReadDto {
  programName?: string;
  suffix?: string;
  outputName?: string;
  outputType?: eTlfOutputType;
  titles: AibBlockLine<IEditorV3>[];
  footnotes: AibBlockLine<IEditorV3>[];
  singles: AioExternalSingleWithSource<IEditorV3>[];
  changedTitles?: GridItemTrafficLight[];
  shellMinorVersion: number;
  comments: CommentReadDto[];
}

/**
 * Type guard that asserts whether a value conforms to the TitlesFootnotesReadDto shape.
 *
 * @param obj - The object to check
 * @returns boolean
 */
export const isTitlesFootnotesReadDto = (obj: unknown): obj is TitlesFootnotesReadDto => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check lower interface
  if (!isTlfItemIndexReadDto(obj)) return false;

  // Check basic props
  if (obj.programName !== undefined && typeof obj.programName !== "string") return false;
  if (obj.suffix !== undefined && typeof obj.suffix !== "string") return false;
  if (obj.outputName !== undefined && typeof obj.outputName !== "string") return false;
  if (
    obj.outputType !== undefined &&
    (typeof obj.outputType !== "string" ||
      !Object.values(eTlfOutputType).includes(obj.outputType as eTlfOutputType))
  )
    return false;
  if (typeof obj.shellMinorVersion !== "number") return false;

  // Check arrays
  if (!Array.isArray(obj.titles) || !Array.isArray(obj.footnotes)) return false;
  if (!Array.isArray(obj.comments) || obj.comments.some((x) => !isCommentReadDto(x))) return false;
  if (!Array.isArray(obj.changedTitles) && obj.changedTitles !== undefined) return false;

  // Check array contents
  if (obj.changedTitles?.some((x) => !isGridItemTrafficLight(x))) return false;
  if (!Array.isArray(obj.singles) || obj.singles.some((o) => !isAioExternalSingle(o, isIEditorV3)))
    return false;

  // Everything is good
  return true;
};
